module.exports = __webpack_public_path__ + "static/scale-model-of-louisville-downtown-partnership-in-louisville-kentucky-647440bf4cc2e85dbb66c36e57b36ee2.png";